import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { HeaderAppComponent } from 'src/app/shared/components/header-app/header-app.component';
import { HeaderPublicComponent } from 'src/app/shared/components/header-public/header-public.component';
import { FooterAppComponent } from 'src/app/shared/components/footer-app/footer-app.component';
import { FooterComponent } from 'src/app/shared/components/footer/footer.component';

@Component({
  selector: 'app-legal-layout',
  imports: [
    RouterOutlet,
    HeaderAppComponent,
    HeaderPublicComponent,
    FooterAppComponent,
    FooterComponent,
  ],
  template: `
    <div class="flex flex-col min-h-screen">
      @if (auth.isLoggedIn()) {
        <app-header-app></app-header-app>
        <main class="pt-16 flex-grow flex flex-col">
          <router-outlet></router-outlet>
        </main>
        <app-footer-app></app-footer-app>
      } @else {
        <app-header-public></app-header-public>
        <main class="flex-grow flex flex-col">
          <router-outlet></router-outlet>
        </main>
        <app-footer></app-footer>
      }
    </div>
  `,
})
export class LegalLayoutComponent {
  auth = inject(AuthService);
}
